import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  Card,
  CardContent,
  Typography,
  CardHeader,
  Tooltip,
} from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

const StyledHeader = styled.span`
  float: right;
`;

const StatCard = ({ stat, title, image, tooltip }) => {
  return (
    <Card style={{ height: "178px" }}>
      <CardHeader
        title={
          <StyledHeader>
            <Tooltip
              title={<Typography>{tooltip}</Typography>}
              aria-label={tooltip}
            >
              <HelpOutlineIcon />
            </Tooltip>
          </StyledHeader>
        }
        style={{ padding: "8px 8px 0 0" }}
      />
      <CardContent
        style={{
          paddingTop: "0",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {image}
        <Typography
          style={{
            fontSize: "24px",
            fontWeight: 500,
            lineHeight: "28px",
            textAlign: "center",
            marginBottom: "10px",
          }}
        >
          {stat}
        </Typography>
        <Typography variant="body1" style={{ color: "#949494" }}>
          {title}
        </Typography>
      </CardContent>
    </Card>
  );
};

StatCard.propTypes = {
  stat: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.objectOf(PropTypes.any).isRequired,
  tooltip: PropTypes.string.isRequired,
};

export default StatCard;
